import { render, staticRenderFns } from "./guardia.vue?vue&type=template&id=5f2d60ee&scoped=true"
import script from "./guardia.vue?vue&type=script&lang=js"
export * from "./guardia.vue?vue&type=script&lang=js"
import style0 from "./guardia.vue?vue&type=style&index=0&id=5f2d60ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d60ee",
  null
  
)

export default component.exports